import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
UniLimiter
PROPS:
props.w
props.maxWidth
props.minWidth
props.maximize
props.minimize
props.fullWidth
props.extraClass
*/

const UniLimiter = (props) => {
  let style = {};
  if (props.w > 0 || props.w === 0) {
    /*
    style = {
      // flexBasis: props.w, // OLD
      // width: props.w, // NEW v2
      maxWidth: props.w,
    };
    */
    style.width = props.w;
  }
  if (props.maxWidth > 0 || props.maxWidth === 0) {
    /*
    style = {
      // flexBasis: props.w, // OLD
      // width: props.w, // NEW v2
      maxWidth: props.w,
    };
    */
    style.maxWidth = props.maxWidth;
  }
  if (props.minWidth > 0 || props.minWidth === 0) {
    style.minWidth = props.minWidth;
  }

  let cl = '';
  if (props.maximize === true) { // unlimit the limiter
    cl = " unicompo-limiter--maximize";
  }
  if (props.minimize === true) {
    cl = " unicompo-limiter--minimize";
  }
  if (props.fullWidth === true) { // width to 100%
    cl = " unicompo-limiter--full-width";
  }

  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }

  return (
    <div className={"unicompo-limiter" + cl + extraClass} style={style}>{props.children}</div>
  );
};

export default UniLimiter;